import { useLocation as useLocationBase } from 'react-router-dom';
/**
 * React Router の useLocation をラップしたカスタムフック
 */
export const useLocation = () => {
    const location = useLocationBase();
    return location;
};
